import React, { useState, useRef, useEffect } from 'react';
import { Download, ChevronDown, FileText, FileSpreadsheet, File } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const ExportDropdown = ({ onExportExcel, onExportCSV, onExportPDF, isDark }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handle = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, []);

  const options = [
    {
      label: 'Export as Excel',
      icon: FileSpreadsheet,
      color: '#10B981',
      action: () => { onExportExcel?.(); setOpen(false); },
    },
    {
      label: 'Export as CSV',
      icon: FileText,
      color: '#3B82F6',
      action: () => { onExportCSV?.(); setOpen(false); },
    },
    {
      label: 'Export as PDF',
      icon: File,
      color: '#EF4444',
      action: () => { onExportPDF?.(); setOpen(false); },
    },
  ];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(o => !o)}
        className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-bold border-0 text-white shadow-md transition-all ${
          isDark
            ? 'bg-gradient-to-r from-[#284BB3] to-[#4F7DFF] hover:shadow-lg hover:opacity-95'
            : 'bg-gradient-to-r from-[#1a3884] to-[#284BB3] hover:shadow-lg hover:opacity-95'
        }`}
      >
        <Download size={14} />
        Export
        <ChevronDown size={13} className={`transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -6, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -6, scale: 0.97 }}
            transition={{ duration: 0.15 }}
            className={`absolute right-0 mt-2 w-52 rounded-2xl border shadow-xl z-50 overflow-hidden ${
              isDark ? 'bg-[#0F225C] border-[#1a3884]/60' : 'bg-white border-gray-200'
            }`}
          >
            <div className="py-1.5">
              {options.map(({ label, icon: Icon, color, action }) => (
                <button
                  key={label}
                  onClick={action}
                  className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm font-semibold transition-all text-left ${
                    isDark
                      ? 'text-gray-200 hover:bg-[#1a3884]/40'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <span
                    className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{ background: color + '22' }}
                  >
                    <Icon size={14} style={{ color }} />
                  </span>
                  {label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ExportDropdown;
